import { Vue, Component, Prop } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms'; 
import { ComponentTerms as compTerms} from '@/const/terms/componentTerms';

import { IAPP } from '@/const/types';
import { FormType, IFormatData } from '@/pages/adFolder/editingTypes';
import { ElUploadInternalFileDetail } from 'element-ui/types/upload';

import AdFolderUploadTable from './AdFolderUploadTable.vue';


@Component<AdFolderForm>({
    name: 'AdFolderForm',
    components: {
        AdFolderUploadTable,
    }
})
export default class AdFolderForm extends Vue {
    @Prop({type: Object, required: true}) private value!: FormType;
    @Prop({type: Array, required: true}) private data!: IFormatData[];
    @Prop({type: Array, required: true}) private appList!: IAPP[];
    @Prop({type: Boolean, required: true}) private isEdit!: boolean;
    @Prop({type: Boolean, required: true}) private loading!: boolean;
    
    get form() { return this.value }
    set form(v: FormType) { this.$emit('input', v) }

    get loadingSync() { return this.loading }
    set loadingSync(v: boolean) { this.$emit('update:loading', v) }

    private compTerms = compTerms;

    private imgVisible: boolean = false;
    private clickedImg: {id: string, src: string} = {id: '', src: ''};
    
    get clickedImgTitle() {
        return '[' + terms.ad.default + ' ID] ' + this.clickedImg.id;
    }
    private hideCreative() {
        this.imgVisible = false;
        this.clickedImg = {id: '', src: ''};
    }

    public handleChange(file: ElUploadInternalFileDetail, fileList: ElUploadInternalFileDetail[], row: IFormatData ) {
        this.$emit('change', file, fileList, row);
    }
    
}